import React from 'react';
import PropTypes from 'prop-types';
import { useIdentity } from '../../../Authentication/Authentication.hooks';
import {
  STEPS,
  useAuthState
} from '../../../Authentication/Authentication.context';

import * as Styled from './FreeShippingUpsell.styled';
import OfferMessage from '../../../OfferMessage/OfferMessage';
import ConfirmationIcon from '../../../Icons/ConfirmationIcon/ConfirmationIcon';

/**
 * Encourages a customer to authenticate for Free Shipping
 */
const FreeShippingUpsell = ({
  className,
  backgroundColor,
  shippingPolicy,
  enableNewOfferMessage,
  withDivider
}) => {
  const { user } = useIdentity();
  const { setIsDialogOpen, setCurrentStep } = useAuthState();

  const LOGIN = { ...STEPS.LOGIN, hideAccountNav: true };

  const handleLoginClick = () => {
    setCurrentStep(LOGIN);
    setIsDialogOpen(true);
  };

  const props = enableNewOfferMessage
    ? { version: 'minimal', padding: '8px' }
    : { backgroundColor, version: 'background' };

  const shouldShowDivider = enableNewOfferMessage && withDivider;

  const infoDialogElement = (
    <Styled.InfoDialog
      cta="Learn More"
      title={shippingPolicy.title}
      sections={shippingPolicy.sections}
    />
  );

  return (
    <>
      <Styled.FreeShippingUpsell className={className}>
        {user.isLoggedIn ? (
          <OfferMessage
            {...props}
            title="Enjoy free standard shipping on your order."
            subtitle="It'll be applied upon checkout."
            rightComponent={<ConfirmationIcon />}
          />
        ) : (
          <>
            <OfferMessage
              {...props}
              title="Want free standard shipping on your order?"
              subtitle="All you need is a Bombas account."
              primaryActionText="Log In or Sign Up"
              onPrimaryActionClick={handleLoginClick}
              secondaryAction={infoDialogElement}
            />
          </>
        )}
      </Styled.FreeShippingUpsell>
      {shouldShowDivider && <Styled.Divider />}
    </>
  );
};

FreeShippingUpsell.propTypes = {
  className: PropTypes.string,
  /**
   * background color option
   */
  backgroundColor: PropTypes.string,
  /**
   * shipping policy from contentful
   */
  shippingPolicy: PropTypes.shape({
    cta: PropTypes.string,
    display: PropTypes.bool,
    title: PropTypes.string,
    sections: PropTypes.arrayOf(PropTypes.shape({})),
    defaultSection: PropTypes.shape({})
  }),
  /**
   * enable new offer message
   */
  enableNewOfferMessage: PropTypes.bool,
  /**
   * whether divider shows or not
   */
  withDivider: PropTypes.bool
};

FreeShippingUpsell.defaultProps = {
  className: '',
  backgroundColor: undefined,
  shippingPolicy: {},
  enableNewOfferMessage: false,
  withDivider: false
};

export default FreeShippingUpsell;
